import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import styles from "../Settings.module.scss";
import * as api from "../../../api/index";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import ReferrerList from "./ReferrerList";
import AddEditReferrer from "./AddEditReferrer";
import { getReferrers } from "actions/referrers.action";

const Referrers = (props) => {
  const [addnewform, setaddnewform] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const dispatch = useDispatch();
  const closeform = () => {
    setaddnewform(false);
  };
  React.useEffect(() => {
    if (props.onClose === false) {
      closeform();
    }
  }, [props.onClose]);

  const handleSubmit = async (event) => {
    try {
      setIsSubmitting(true);
      let type;
      if (event.forMatters && event.forClients) {
        type = "Both";
      } else if (event.forMatters) {
        type = "Matter";
      } else if (event.forClients) {
        type = "Client";
      } else {
        type = "Both";
      }
      const postingData = {
        data: {
          ...event,
          active: true,
          referrerType: type,
        },
      };
      await api.addReferrer(postingData);
      toast.success("Referrer Added");
      dispatch(getReferrers());
      setaddnewform(false);
    } catch (error) {
      toast.error("Error Occurred");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <React.Fragment>
      <>
        <div className="row mb-3">
          <div className="col-lg-10 col-md-8"></div>
          <Button
            className={`common-btn col-lg-1 col-md-4 p-2 mt-5 ${
              styles[`button`]
            }`}
            onClick={() => {
              setaddnewform(true);
            }}
          >
            Add <br></br>
            Referrer
          </Button>
        </div>
        <div className="settings-grid-wrapper referrer-grid-wrapper">
          <ReferrerList />
        </div>
      </>
      {addnewform && (
        <AddEditReferrer
          cancelEdit={closeform}
          onSubmit={handleSubmit}
          type="addNew"
          isSubmitting={isSubmitting}
        />
      )}
    </React.Fragment>
  );
};

export default Referrers;
